// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"b8b26c85","667":"bd458851","787":"fbb8f31a"}[chunkId] + ".chunk.js";
};